import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";
import { IoMdStar } from "react-icons/io";
import { FaArrowRightLong } from "react-icons/fa6";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await api({
          url: SummaryApi.getAllTestimonials.url,
          method: SummaryApi.getAllTestimonials.method,
        });

        // ✅ filter only published
        const published = res?.data?.data?.filter(
          (t) => t.status === "Publish"
        );

        // ✅ show max 4
        setTestimonials(published?.slice(0, 4) || []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <section className="w-full bg-[#45A301]/5 py-12">
      <div className="max-w-7xl mx-auto px-4">

        {/* TITLE */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl text-[#2F2F2F] mb-4 font-times">
            What Our Clients Say
          </h2>
          <p className="text-[#2F2F2F] text-sm md:text-base max-w-2xl mx-auto">
            Real experiences from people who trusted KL Property to purchase land
            in Idukki, Thekkady, and Kumily.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.length === 0 ? (
            <div className="col-span-full text-center text-gray-500 py-6">
              No testimonials available
            </div>
          ) : (
            testimonials.map((item) => (
              <div
                key={item._id}
                className="bg-white rounded-xl p-6 transition"
              >
                {/* STARS */}
                <div className="flex text-[#7C9A6D] mb-3">
                  {[...Array(item.rating || 5)].map((_, i) => (
                    <IoMdStar key={i} />
                  ))}
                </div>

                {/* REVIEW */}
                <p className="text-[#2F2F2F] text-sm mb-6 leading-relaxed">
                  "{item.review}"
                </p>

                {/* USER */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gray-300 rounded-full overflow-hidden">
                    {item.photo?.url ? (
                      <img
                        src={item.photo.url}
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs text-gray-500">
                        NA
                      </div>
                    )}
                  </div>

                  <div>
                    <p className="text-sm font-bold text-[#2F2F2F]">
                      {item.name}
                    </p>
                    <p className="text-xs text-[#2F2F2F99]">
                      {item.location}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* BUTTON */}
        <div className="flex justify-center">
          <button
            onClick={() => navigate("/testimonials")}
            className="bg-[#45A301] text-white px-5 py-2.5 rounded-lg flex items-center gap-2 hover:bg-[#3e9202] transition mt-16"
          >
            View More Testimonials
             <FaArrowRightLong />
            
          </button>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;